import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { CodeBlock } from '@/components/app/CodeBlock';
import { DiffViewer } from './DiffViewer';
import type { NotificationAdminAudit } from '../types';

interface AuditDiffViewerProps {
  entry: NotificationAdminAudit;
}

export function AuditDiffViewer({ entry }: AuditDiffViewerProps) {
  return (
    <Tabs defaultValue="diff" className="w-full">
      <TabsList>
        <TabsTrigger value="diff">Diff</TabsTrigger>
        <TabsTrigger value="before">Before</TabsTrigger>
        <TabsTrigger value="after">After</TabsTrigger>
        <TabsTrigger value="raw">Raw</TabsTrigger>
      </TabsList>
      <TabsContent value="diff">
        {entry.diff && entry.diff.length > 0 ? (
          <ul className="divide-y rounded-md border bg-muted/20 text-xs">
            {entry.diff.map((line, i) => (
              <li key={i} className="px-3 py-1.5 font-mono">{line}</li>
            ))}
          </ul>
        ) : (
          <DiffViewer before={entry.before} after={entry.after} />
        )}
      </TabsContent>
      <TabsContent value="before">
        <CodeBlock value={entry.before ?? null} />
      </TabsContent>
      <TabsContent value="after">
        <CodeBlock value={entry.after ?? null} />
      </TabsContent>
      <TabsContent value="raw">
        <CodeBlock value={entry} />
      </TabsContent>
    </Tabs>
  );
}
